<template>
  <v-snackbar
    v-model="show"
    :color="color"
    :timeout="timeout"
    right
  >
    {{ notificationText }}
    <v-btn
      color="pink"
      flat
      @click="show = false"
    >
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
    import { mapState } from 'vuex';
    export default {
        name: "NotificationPopup",
        data() {
            return {
                show: false,
                color: 'primary',
                notificationText: '',
                timeout: 4500,
            }
        },
        mounted()
        {
            let self = this;
            self.$store.subscribe((mutation, state) => {
                if (mutation.type === 'notification/showNotificationInternal')
                {
                    self.displayNotification(state.notification.internal);
                }
            });
            self.$store.commit('notification/clearNotificationInternal', {});
        },
        methods: {
            displayNotification(notification)
            {
                let self = this;

                if (notification.msg === '')
                {
                    return;
                }

                //{type:payload.type, msg: payload.msg}

                let color = 'primary';

                switch (notification.type) {
                    case 'info':
                        color = 'primary';
                        break;
                    case 'error':
                        color = 'error';
                        break;
                }

                self.color = color;
                self.notificationText = self.$t(notification.msg);
                self.show = true;

                self.$store.commit('notification/clearNotificationInternal', {});
            }
        },
    }
</script>

<style scoped>

</style>